// API DOMAIN
const DEV_ORIGIN = 'http://127.0.0.1:8000'
const PROD_ORIGIN = process.env.VUE_APP_PUBLIC_HOST
	|| (typeof window !== 'undefined' && window.location ? window.location.origin : DEV_ORIGIN)
const CURRENT_ORIGIN = process.env.NODE_ENV === 'development' ? DEV_ORIGIN : PROD_ORIGIN
const API_DOMAIN = CURRENT_ORIGIN.replace(/^https?:\/\//, '')
//lyadmin系统配置
module.exports = {

    //API DOMAIN
    API_DOMAIN : API_DOMAIN,

    //接口地址
    // API_URL : process.env.NODE_ENV === 'development' ? "http://"+ API_DOMAIN +"/api/" : "https://"+ API_DOMAIN +"/api/",
    // API_URL : "http://ldbk.bnu.edu.cn",
    // API_URL : "http://192.168.2.120:8000/api/",
    // API_URL : "http://ldbk.bnu.edu.cn/bill-api/api/",
    // API_URL1 : "http://192.168.2.120:8000",
    // API_URL1 : "https://hz.bnu.edu.cn/bill/",
	API_URL : `${CURRENT_ORIGIN}/api/`,
	API_URL1 : CURRENT_ORIGIN,

    //标题
    APP_TITLE : "伟仕佳杰后台管理系统",

	//是否开启多标签
	ISMULTITABS: true,

	//语言 简体中文 zh-cn、 英文 en（此功能只是示例）
	LANG: 'zh-cn',

	// elementplus 组件大小： small、default、large
	ELEMENT_SIZE: 'small',

	// elementplus 组件 zIndex
	ELEMENT_ZINDEX: 3000,

	// elementplus button组件 autoInsertSpace 是否自动在两个中文字符之间插入空格
	ELEMENT_BUTTON: false,

	//左侧菜单默认宽度 默认 185
	MENU_WIDTH: 200,

	// 左侧菜单和顶部导航颜色 默认 #3C444D
	MENU_HEADER_COLOR:'#3C444D',

	//主题颜色 默认 #409EFF
	COLOR: '#409EFF',

    //默认主题 'dark' 暗黑、'light' 正常
	THEME: 'light',

    //登录信息数据存储方式 localStorage、sessionStorage
	STORAGE_METHOD: 'localStorage',

}